import VenueAPI from "./VenueAPI";
import DrupalParser from "./DrupalParser";
import CustomVenueAPI from "./CustomVenueAPI";
import FilterHelper from "./FilterHelper";

class VenueRepository {
  constructor() {
    this.customVenueApi = new CustomVenueAPI();
    this.filterHelper = new FilterHelper();
    this.filters = [];
    this.filterLabels = [];
    this.filterObjects = {};
    this.filterQueryString = "";
  }

  getAllVenues() {
    let venueApi = new VenueAPI();
    let fields = {'node--venue' : 'drupal_internal__nid,title,path,field_venue_type,field_capacity,field_preferred_partner,field_sustainable,field_keyvisual,field_location_data'};
    let includes = 'field_venue_type,field_keyvisual';
    let paging = 9;
    venueApi.defineFields(fields);
    venueApi.defineIncludes(includes);
    venueApi.setPaging(paging);

    return venueApi.callApi().then((result) => {
      let parser = new DrupalParser(result, fields, includes);
      return parser.parse();
    });
  }

  applyFilters() {
    /*
      * If field new in filter field is new OR group
      * If field exists update OR group
      * If multiple fields,  join fields in AND group
      * */
    let queryString = "";
    Object.keys(this.filterObjects).forEach((value) => {
      if (this.filterHelper.isFilterType(value, 'range')) {
        queryString = this.filterOnRange(queryString, value);
      }
      if (this.filterHelper.isFilterType(value, 'term')) {
        queryString = this.filterOnTerm(queryString, value);
      }
      if (this.filterHelper.isFilterType(value, 'boolean')) {
        queryString = this.filterOnBoolean(queryString, value);
      }
      if (this.filterHelper.isFilterType(value, 'search')) {
        queryString = this.filterOnSearch(queryString, value);
      }
/*
      if (this.filterHelper.isBooleanFilter(this.filterObjects[value])) {
        queryString = this.filterOnTerm(queryString, value);
      }
*/
    });
    this.filterQueryString = queryString;
  }

  addFilterLabels(keyValues) {
    this.filterLabels[keyValues.name+'_'+keyValues.value] = keyValues.label;
  }

  filterOnBoolean(queryString, value) {
    queryString += '&filter[' + value + ']=' + 1;
    return queryString;
  }

  filterOnSearch(queryString, value) {
    let originalQueryString = queryString;
    if (this.filterObjects[value]) {
      queryString += '&filter[filter_' + value + '][condition][path]=title';
      queryString += '&filter[filter_' + value + '][condition][operator]=CONTAINS';
      queryString += '&filter[filter_' + value + '][condition][value]=' + this.filterObjects[value];
    }
    return queryString;
  }

  filterOnRange(queryString, value) {
    let originalQueryString = queryString;
    if (this.filterObjects[value].min && this.filterObjects[value].max) {
      queryString += '&filter[filter_' + value + '_min][condition][path]=' + value + '';
      queryString += '&filter[filter_' + value + '_min][condition][operator]=%3E%3D';
      queryString += '&filter[filter_' + value + '_min][condition][value]=' + this.filterObjects[value].min;

      queryString += '&filter[filter_' + value + '_max][condition][path]=' + value + '';
      queryString += '&filter[filter_' + value + '_max][condition][operator]=%3C%3D';
      queryString += '&filter[filter_' + value + '_max][condition][value]=' + this.filterObjects[value].max;

    }
    return queryString;
  }

  filterOnTerm(queryString, value) {
    let originalQueryString = queryString;
    if (this.filterObjects[value].length > 0) {
      queryString += '&filter[filter_' + value + '][condition][path]=' + value + '.tid';
      queryString += '&filter[filter_' + value + '][condition][operator]=IN';
      let valuesSet = false;
      for (let selectedValue in this.filterObjects[value]) {
        queryString += '&filter[filter_' + value + '][condition][value][]=' + this.filterObjects[value][selectedValue];
        valuesSet = true;
      }
      //Quick hack for emptying filters
      if (!valuesSet) {
        queryString = originalQueryString;
      }

    }
    return queryString;
  }

  updateFilters(filterObject, url) {
    Object.keys(filterObject).forEach((property) => {
      let propertyValue = filterObject[property];
      if ('object' === typeof propertyValue && propertyValue.min) {
        this.filterObjects[property] = propertyValue; // ToDo: Combine with next if?
      } else if ('object' === typeof propertyValue && !propertyValue.min) {
        delete this.filterObjects[property];
      }
      if (property === 'field_search') {
        this.filterObjects[property] = propertyValue;
        if (propertyValue === "") {
          delete this.filterObjects[property];
        }
      }
      if ((Array.isArray(propertyValue) && propertyValue.length > 0) || (!Array.isArray(propertyValue) && propertyValue !== 0)) {
        this.filterObjects[property] = propertyValue;
      }
      if (Array.isArray(propertyValue) && propertyValue.length === 0) {
        delete this.filterObjects[property];
      }
    });
  }

  addFilters(url) {
    if(this.filterQueryString.length) {
      if (url.includes('?')) {
        return decodeURIComponent(url) + this.filterQueryString;
      } else {
        return decodeURIComponent(url) + this.filterQueryString.replace('&','?');
      }
    }
    return url;
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }

    return false;
  }

  /**
   * Used for paging
   * @param url
   * @returns {*}
   */
  callUrl(url) {
    let venueApi = new VenueAPI();
    let fields = {'node--venue' : 'drupal_internal__nid,title,path,field_venue_type,field_capacity,field_preferred_partner,field_sustainable,field_keyvisual,field_location_data'};
    let includes = 'field_layout,field_area,field_venue_type,field_keyvisual';

    url = this.addFilters(url);
    return venueApi.callUrl(url).then((result) => {
      let parser = new DrupalParser(result, fields, includes);
      return parser.parse();
    });
  }

  /**
   * Used for paging
   * @param url
   * @returns {*}
   */
  callFilterUrl(disablePaging) {
    let venueApi = new VenueAPI();
    let fields = {'node--venue' : 'drupal_internal__nid,title,path,field_venue_type,field_capacity,field_preferred_partner,field_sustainable,field_keyvisual,field_location_data'};
    let includes = 'field_layout,field_area,field_venue_type,field_keyvisual';
    let paging = 9;

    venueApi.defineFields(fields);
    venueApi.defineIncludes(includes);
    if (disablePaging !== true) {
      venueApi.setPaging(paging);
    }
    //toDo selt filterObjects instead of string, let string be generated by venue api, time consuming, leave it now
    venueApi.setFilters(this.filterQueryString);

    return venueApi.callApi().then((result) => {
      let parser = new DrupalParser(result, fields, includes);
      return parser.parse();
    });
  }

  getMinMaxField(fieldName) {
    return this.customVenueApi.callGetFilterApi('minmax', fieldName).then((result) => {
      return result;
    });
  }

  getCheckboxField(fieldName) {
    return this.customVenueApi.callGetFilterApi('checkbox', fieldName).then((result) => {
      return result;
    });
  }
}

export default VenueRepository;
